// Категории новостей: ключ хранится в базе, подпись берётся из переводов
export const POST_CATEGORIES = [
  { key: "real-estate", label: "news.realEstate" },
  { key: "residence", label: "news.residence" },
  { key: "investments", label: "news.investments" },
  { key: "turkey-news", label: "news.turkeyNews" },
  { key: "advice", label: "news.advice" },
];

export const categoryLabel = (t, key) => {
  const found = POST_CATEGORIES.find((c) => c.key === key);
  return found ? t(found.label) : key || "";
};
